import { db } from '@/config/firebase';

export default {
    subscribeToList: (name, email) => {
        let subscriber = {
            name: name,
            email: email,
            dateSubscribed: new Date().getTime()
        }

        return db.collection("subscribers").add(subscriber).then(function (docRef) {
            return {
                isSuccess: true,
                data: docRef.id
            };
        }).catch(function (error) {
            return {
                isSuccess: false,
                data: error
            };
        });
    }
};